import { useTranslations } from 'next-intl'
import Paragraph from './Paragraph'

const SandboxBanner = () => {
    const t = useTranslations('root')

    return (
        <div
            className="h-[35px] flex items-center justify-center gap-1 p-2 bg-backgroundForest"
            data-testid="__v2-sandbox-banner__"
        >
            <Paragraph color="light">{t('sandboxMode')}</Paragraph>
        </div>
    )
}

export default SandboxBanner
